// i18n.js
import { createI18n } from "vue-i18n";
import { lang } from "@/util/base";

// 导入语言文件
import en from "./lang/en";
import cn from "./lang/cn";
import es from "./lang/es";
import pt from "./lang/pt";

const i18n = createI18n({
  locale: lang(), // 默认语言
  messages: {
    en,
    cn,
    es,
    pt,
  },
  allowComposition: true, // you need to specify that!
  legacy: false, // 如果要支持compositionAPI，此项必须设置为false;
  globalInjection: true, // 全局注册$t方法
});

export default i18n;
